import React from 'react';

const WhyChooseUs = () => {
  return (
    <section className="bg-gradient-to-br from-slate-50 via-slate-100 to-slate-50 py-16 md:py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
          {/* Left Column - Heading */}
          <div className='lg:col-span-4'>
          <div className=" space-y-6">
            {/* Tag */}
            <div className="inline-flex items-center gap-2 px-6 py-3 bg-white border border-slate-300 rounded-full">
              <span className="text-slate-900 text-sm">✦</span>
              <span className="text-slate-900 font-medium">Why Choose Us</span>
            </div>

            {/* Heading */}
            <div className="space-y-2">
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 leading-tight">
                Building <span className="font-serif italic">Trust,</span>
              </h2>
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 leading-tight">
                Creating <span className="font-serif italic">Value.</span>
              </h2>
            </div>

            {/* Description */}
            <p className="text-slate-600 text-lg leading-relaxed">
              We build lasting partnerships based on trust and deliver real, measurable value through strategic insight and collaboration.
            </p>
          </div>
          
             <div className="flex justify-center mt-12 ">
          <div className="w-80 h-80 bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900 rounded-full flex flex-col items-center justify-center shadow-2xl">
            <div className="text-center">
              <div className="flex items-baseline justify-center mb-4">
                <span className="text-7xl font-bold text-white">300</span>
                <span className="text-5xl font-bold text-white">%</span>
              </div>
              <p className="text-white text-lg font-medium px-8">
                Growth Achieved Through<br/>Strategic Guidance
              </p>
            </div>
          </div>
        </div>
          </div>

          {/* Right Column - Feature Cards Grid */}
          <div className="lg:col-span-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Card 1 - Proven Business Results */}
              <div className="bg-white rounded-3xl border border-slate-200 p-8 hover:shadow-xl transition-shadow duration-300">
                <div className="mb-6">
                  <div className="w-16 h-16 flex items-center justify-center">
                    <svg className="w-16 h-16 text-slate-900" viewBox="0 0 64 64" fill="none" stroke="currentColor">
                      <circle cx="32" cy="32" r="28" strokeWidth="2"/>
                      <circle cx="32" cy="32" r="20" strokeWidth="2"/>
                      <circle cx="32" cy="32" r="12" strokeWidth="2"/>
                      <path d="M24 28l4 4 8-8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-4">
                  PROVEN BUSINESS<br/>RESULTS
                </h3>
                <div className="w-12 border-t border-slate-300 mb-4"></div>
                <p className="text-slate-600 leading-relaxed">
                  We combine creativity and strategy to help brands stand out, connect, inspire, and grow effectively.
                </p>
              </div>

              {/* Card 2 - Tailored Growth Strategies */}
              <div className="bg-white rounded-3xl border border-slate-200 p-8 hover:shadow-xl transition-shadow duration-300">
                <div className="mb-6">
                  <div className="w-16 h-16 flex items-center justify-center">
                    <svg className="w-16 h-16 text-slate-900" viewBox="0 0 64 64" fill="none" stroke="currentColor">
                      <rect x="16" y="40" width="8" height="16" strokeWidth="2"/>
                      <rect x="28" y="32" width="8" height="24" strokeWidth="2"/>
                      <rect x="40" y="24" width="8" height="32" strokeWidth="2"/>
                      <path d="M20 28L32 20L44 12" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <circle cx="44" cy="12" r="2" fill="currentColor"/>
                    </svg>
                  </div>
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-4">
                  TAILORED GROWTH<br/>STRATEGIES
                </h3>
                <div className="w-12 border-t border-slate-300 mb-4"></div>
                <p className="text-slate-600 leading-relaxed">
                  Campaigns focused on delivering results, driving awareness, boosting engagement, and creating lasting impact.
                </p>
              </div>

              {/* Card 3 - Long-Term Partnerships */}
              <div className="bg-white rounded-3xl border border-slate-200 p-8 hover:shadow-xl transition-shadow duration-300">
                <div className="mb-6">
                  <div className="w-16 h-16 flex items-center justify-center">
                    <svg className="w-16 h-16 text-slate-900" viewBox="0 0 64 64" fill="none" stroke="currentColor">
                      <circle cx="32" cy="32" r="24" strokeWidth="2"/>
                      <circle cx="32" cy="24" r="6" strokeWidth="2"/>
                      <circle cx="20" cy="36" r="6" strokeWidth="2"/>
                      <circle cx="44" cy="36" r="6" strokeWidth="2"/>
                      <path d="M32 30v6M26 36l-6 0M38 36l6 0" strokeWidth="2" strokeLinecap="round"/>
                    </svg>
                  </div>
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-4">
                  LONG-TERM<br/>PARTNERSHIPS
                </h3>
                <div className="w-12 border-t border-slate-300 mb-4"></div>
                <p className="text-slate-600 leading-relaxed">
                  Customized solutions designed around your goals, ensuring each message resonates and strengthens presence.
                </p>
              </div>

              {/* Card 4 - Future-Focused Thinking */}
              <div className="bg-white rounded-3xl border border-slate-200 p-8 hover:shadow-xl transition-shadow duration-300">
                <div className="mb-6">
                  <div className="w-16 h-16 flex items-center justify-center">
                    <svg className="w-16 h-16 text-slate-900" viewBox="0 0 64 64" fill="none" stroke="currentColor">
                      <circle cx="32" cy="32" r="26" strokeWidth="2"/>
                      <path d="M32 16v16l8 8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <circle cx="32" cy="32" r="3" fill="currentColor"/>
                    </svg>
                  </div>
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-4">
                  FUTURE-FOCUSED<br/>THINKING
                </h3>
                <div className="w-12 border-t border-slate-300 mb-4"></div>
                <p className="text-slate-600 leading-relaxed">
                  We anticipate change and design strategies that prepare businesses to thrive in evolving markets.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;